// extracted by mini-css-extract-plugin
export default {"container":"SocailContainer_container__4jM3V"};